// Mock data for Dr. Shaji Prabhakaran's portfolio
// This will be replaced by backend APIs once integrated.

export const PROFILE = {
  name: "Prof. Dr. Shaji Prabhakaran",
  honorific: "M.B.B.S, M.D, D.M (Neuro), Ph.D, FRCP (London)",
  tagline: "Neurologist · Academician · Author · Philanthropist",
  motto: "Karmanye Vadhikarasthe, Ma Phaleshu Kadachana",
  mottoMeaning: "Do thy duty, without an eye on the fruits thereof.",
  birth: "9th June 1951, Mayyanad, Kerala, India",
  citizenship: "Indian",
  spouse: "Dr. R. Salma, M.S., DO, DNB (Ophthal)",
  children: "Dr. Nakul. S. — Ph.D Nano Electronics, Wisconsin University, USA",
  current: "Hon. Sr. Consultant Neurologist — Cosmopolitan Hospitals Pvt. Ltd., Trivandrum",
  retired: "Retired Principal — Govt. Medical College, Alappuzha",
  phones: ["+91 94470 68686", "+91 99950 68686", "+91 94959 68686"],
  address: "Aaraamam, Bapuji Nagar, Pongummoodu, Medical College P.O., Thiruvananthapuram – 695011, Kerala, India",
  images: {
    primary: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/8vs6qiwg_WhatsApp%20Image%202026-04-25%20at%2012.36.26g.jpeg",
    consult: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/npg3e71z_WhatsApp%20Image%202026-04-25%20at%2012.36.25f.jpeg",
    desk: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/h858paeb_WhatsApp%20Image%202026-04-25%20at%20gg.jpeg",
    casual: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/c2w9ug6v_WhatsApp%20Image%202026-04-25%20at%2012.36.24d.jpeg",
    portrait: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/3a5ah0y4_WhatsApp%20Image%202026-04-25%20at%2012.36.27ff.jpeg"
  }
};

export const EDUCATION = [
  { year: "1970", degree: "B.Sc. Botany", institution: "University of Kerala" },
  { year: "1975", degree: "M.B.B.S", institution: "University of Kerala" },
  { year: "1980", degree: "D.P.M. (Diploma in Psychological Medicine)", institution: "University of Bombay" },
  { year: "1987", degree: "M.D. (General Medicine)", institution: "University of Kerala" },
  { year: "1989", degree: "D.M. (Neurology)", institution: "University of Kerala" },
  { year: "2006", degree: "Ph.D. (Neurology)", institution: "University of Rochester, USA" },
  { year: "2011", degree: "FRCP", institution: "Royal College of Physicians, London" }
];

export const CAREER = [
  { period: "1977 – 1979", role: "ICMR Research Fellow", place: "Indian Council of Medical Research" },
  { period: "1989 – 2010s", role: "Lecturer, Professor & Principal", place: "Govt. Medical Colleges — Thiruvananthapuram, Alappuzha & Kottayam" },
  { period: "Retired as", role: "Principal", place: "Government Medical College, Alappuzha" },
  { period: "Present", role: "Hon. Sr. Consultant Neurologist", place: "Cosmopolitan Hospitals Pvt. Ltd., Trivandrum" },
  { period: "Since 1996", role: "Research Guide", place: "University of Kerala — guided 20+ MD theses & PhD scholars" }
];

export const BOOKS = [
  { title: "Kazhchappadukal", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/w4kbwblp_WhatsApp%20Image%202026-05-16%20at%2015.22.15.jpeg" },
  { title: "Neuro Samvadham", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/gsobra50_WhatsApp%20Image%202026-05-16%20at%2015.24.25.jpeg" },
  { title: "Thunadathil Kizhakkathil", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/heb1jvya_WhatsApp%20Image%202026-05-16%20at%2015.22.01.jpeg" },
  { title: "Panikkassery", lang: "Malayalam" },
  { title: "Life in the Department of Neurology", lang: "English · with Prof. Dr. K. Rajasekharan Nair", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/nh3zss9u_WhatsApp%20Image%202026-05-16%20at%2015.22.45.jpeg" },
  { title: "Chinthakal", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/x0439a20_WhatsApp%20Image%202026-05-16%20at%2015.25.31.jpeg" },
  { title: "Vivaksha", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/zbwhd8fa_WhatsApp%20Image%202026-05-16%20at%2015.24.08.jpeg" },
  { title: "Vivaksha (2)", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/hk0i1wgo_WhatsApp%20Image%202026-05-16%20at%2015.26.44.jpeg" },
  { title: "Vivaksha (3)", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/5m19blfh_WhatsApp%20Image%202026-05-16%20at%2015.26.09.jpeg" },
  { title: "Kavitha Slokanjali", lang: "Sanskrit / Malayalam" },
  { title: "Asthikatha", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/xru4l4km_WhatsApp%20Image%202026-05-16%20at%2015.23.26.jpeg" },
  { title: "Apramatham", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/ckjj0id9_WhatsApp%20Image%202026-05-16%20at%2015.25.00.jpeg" },
  { title: "Daivadasakam Englishil", lang: "English" },
  { title: "Daivadasakam Thribhasha", lang: "Malayalam · English · Hindi", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/o36dctoz_WhatsApp%20Image%202026-05-16%20at%2015.26.28.jpeg" },
  { title: "Hindu Budhamatham", lang: "Malayalam", cover: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/d5wkguv4_WhatsApp%20Image%202026-05-16%20at%2015.25.17.jpeg" }
];

export const AWARDS = [
  "Abdulkalam Memorial Charitable Society Award",
  "Sukumar Azhikode Award",
  "Dr. Palpu Memorial Award",
  "Guru Nithya Chaithanya Award",
  "World Teachers Day Award",
  "Gandhi Bhavan Institute Award",
  "Anti Narcotic Action Centre of India Award",
  "Viswavedi Sahithya Puraskar Award",
  "Pradama Poojanilayam Award",
  "Doctor's Day Award",
  "Varkala Radhakrishnan Foundation Award",
  "Janakeeya Dr. Puraskaram",
  "Human Rights Activities Excellency Award",
  "Best Tax Payer — Income Tax Dept., Thiruvananthapuram (1999)"
];

export const STATS = [
  { value: "42+", label: "Awards Received" },
  { value: "28+", label: "Trustee / Patron Of" },
  { value: "30+", label: "Years in Medical Education" },
  { value: "20+", label: "MD Theses Guided" },
  { value: "15", label: "Books Authored" },
  { value: "15¢", label: "Land Donated for Anganwadi & Old-age Homes" }
];

export const SPORTS = [
  { title: "State-level Footballer", detail: "Represented at school level — Kerala State competitions.", icon: "Trophy" },
  { title: "Badminton — MCH Team", detail: "Active player during Medical College years.", icon: "Target" },
  { title: "Kalaripayattu Practitioner", detail: "Trained at MCH; lifelong student of Kerala's traditional martial art.", icon: "Swords" },
  { title: "President — Kerala State Kalaripayattu Association", detail: "Held the State Presidency in the year 2000.", icon: "Crown" },
  { title: "Weightlifter", detail: "Competed in weightlifting at university tournaments.", icon: "Dumbbell" },
  { title: "Degree-Fling (Discus) Player", detail: "Athletics — discus throw athlete during academic years.", icon: "Disc" },
  { title: "Maramadi (Bullock-Cart Racing)", detail: "Participant in Kerala's traditional rural sport of Maramadi.", icon: "Footprints" }
];

export const PHILANTHROPY = [
  "Red Cross Society of India",
  "Cancer Remedy Assistance Bureau (CRAB)",
  "Sree Narayana Samskarik Samithi",
  "Y's Men International — Honour Roll",
  "Media Check",
  "Anti Narcotic Action Centre of India (ANACI) — Chairman",
  "Sree Narayana Spiritual Centre — Trustee",
  "Siddha Marma Practitioner's — Chief Patron",
  "Sahithya Panchanan Sankrithi Vedi — Patron",
  "SNDP Kollam — Medical Expert",
  "Sree Narayana Trust, Kollam — Permanent Director Board Member",
  "SSS International — Chairman",
  "Neuro Samvadam Thiruvananthapuram — Chief Organizer",
  "Reader's Club / Pothujana Arogya Vidyabhyasa — Chief Organizer"
];

export const COMMUNITY = [
  { title: "Land Donation", text: "Donated 15 cents of land for two Anganwadis and two Old-age Homes." },
  { title: "Free Monthly Camps", text: "Conducts free community treatment camps every month for underserved patients." },
  { title: "Public Health Education", text: "Organizes regular study classes on public health & preventive medicine." }
];

export const MEDIA = {
  newspapers: ["Mathrubhumi", "Kerala Kaumudi", "Deepika", "The Hindu"],
  channels: ["Doordarshan", "Asianet", "Surya TV", "Amrita TV", "Kairali Channel", "People Channel", "Jaihind TV"],
  editor: [
    { role: "Hon. Editor", title: "Kadumbajyothi (Malayalam Monthly)" },
    { role: "Hon. Editor", title: "Malayala Desam (Malayalam Monthly)" },
    { role: "Chief Editor", title: "Arthek (Malayalam Fortnightly)" },
    { role: "Hon. Editor", title: "Viswavedi" },
    { role: "Hon. Editor", title: "Olymba Lifecare Foundation" },
    { role: "Editor in Chief", title: "Bowdha Publications, Thiruvananthapuram" },
    { role: "Patron", title: "Ayushpandanam (3-monthly journal)" }
  ]
};

export const GALLERY = [
  { src: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/c2w9ug6v_WhatsApp%20Image%202026-04-25%20at%2012.36.24d.jpeg", caption: "In traditional Kerala attire" },
  { src: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/npg3e71z_WhatsApp%20Image%202026-04-25%20at%2012.36.25f.jpeg", caption: "At the consulting room — Cosmopolitan Hospitals" },
  { src: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/h858paeb_WhatsApp%20Image%202026-04-25%20at%20gg.jpeg", caption: "At the writing desk" },
  { src: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/8vs6qiwg_WhatsApp%20Image%202026-04-25%20at%2012.36.26g.jpeg", caption: "At his library of awards" },
  { src: "https://customer-assets.emergentagent.com/job_bfa65d24-5750-42af-b6c6-9d53cdbe222f/artifacts/3a5ah0y4_WhatsApp%20Image%202026-04-25%20at%2012.36.27ff.jpeg", caption: "In a contemplative moment" }
];

// Historical / archival photographs — restored & enhanced via CSS filters
export const HISTORICAL = [
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/2tyh65ht_1.jpg",
    title: "A Younger Dr. Shaji",
    caption: "Portrait amidst memorabilia of public life",
    year: "c. 2005",
    category: "Portrait"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/pel3liga_2.jpg",
    title: "Mayyanad Sangamam",
    caption: "Felicitating Justice S. Sirijagan, Kerala High Court",
    year: "Reg. T. 3894",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/f2pfcjka_3.jpg",
    title: "C. Kesavan Award",
    caption: "Receiving the C. Kesavan Award from Mr. K. E. Mamen",
    year: "Award",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/fp67hlvm_4.jpg",
    title: "An Audience with Royalty",
    caption: "Presenting the author's copy of \"Vivaksha\" to Princess Gowri Lekshmibhai",
    year: "Royal Reception",
    category: "Royal"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/9v4rowcj_5.jpg",
    title: "Gurudharma Pracharana Sevak",
    caption: "State meet inauguration with Hon. Minister Sri. Babu Divakaran",
    year: "State Meet",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/gomu8vmw_6.jpg",
    title: "Social & Charitable Award",
    caption: "Citizen Forum, Pathanapuram — presented by Hon. Minister Sri. Thiruvanchoor Radhakrishnan",
    year: "Charitable",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/hvw7o0j5_7.jpg",
    title: "Jeevan Raksha Award",
    caption: "Presented by Hon. Minister Sri. Kadavoor Sivadasan",
    year: "2002",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/fqptv5f4_8.jpg",
    title: "Anti-Narcotic Day Award",
    caption: "Receiving recognition from Hon. Minister Sri. Ramesh Chennithala",
    year: "2015",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/sw5j88hj_9.jpg",
    title: "Rashtra Seva Award",
    caption: "National Service Award conferred for sustained civic contribution",
    year: "2015",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/c1n8v9rc_10.jpg",
    title: "International Day Against Drug Abuse",
    caption: "Presiding at VJT Hall, Trivandrum — Hon. Minister Sri. Kadavoor Sivadas distributes the award to Magician Master Bhagyanath",
    year: "2003",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/ez06yjx5_11.jpg",
    title: "Observance — World Drug Abuse Day",
    caption: "Presiding at VJT Hall, Trivandrum — function inaugurated by Hon. Minister Sri. K. P. Mohanan, with Most Rev. Dr. Susa Pakiam (Metropolitan Arch Bishop) & Adv. K. Chandrika (Mayor of Trivandrum)",
    year: "2013",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/moix9pyl_12.jpg",
    title: "Bed-Sheets for the Poor",
    caption: "Donating bed-sheets to patients of Ward 9, General Hospital, Trivandrum",
    year: "Charity",
    category: "Service"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/2ourc566_13.jpg",
    title: "Ponnada from Sri. Oommen Chandy",
    caption: "Receiving the Ponnada from Sri. Oommen Chandy (Leader of the Opposition) at the C. Kesavan Smaraka Award distribution",
    year: "Felicitation",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/fd2kyzf3_14.jpg",
    title: "World Epilepsy Day Walk",
    caption: "Public awareness march led by Neuro Samvadam — bringing brain health to the streets",
    year: "Awareness",
    category: "Service"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/io93h92u_15.jpg",
    title: "Karma Sreshta Award",
    caption: "Receiving the Karma Sreshta Award from Hon. Minister Sri. Kadavoor Sivadasan",
    year: "Award",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/5kabptzw_16.jpg",
    title: "Book Release — \"Kazhchappadukal\"",
    caption: "Releasing his book Kazhchappadukal with Hon. Minister Sri. G. Sudhakaran",
    year: "Book Release",
    category: "Author"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/vm34rshq_17.jpg",
    title: "Onam Gifts to the Poor",
    caption: "Presenting Onam gifts to underprivileged families — a yearly tradition",
    year: "Onam",
    category: "Service"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/p8t7omrm_18.jpg",
    title: "K. Sukumaran Memorial",
    caption: "Placing a wreath at the death anniversary of Kerala Kaumudi Pathradhipar Sri. K. Sukumaran",
    year: "Memorial",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/ujufpm9r_19.jpg",
    title: "Neuro Samvadam — III",
    caption: "Stroke awareness symposium inaugurated by Hon. Speaker Sri. Therambil Ramakrishnan",
    year: "Symposium",
    category: "Service"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/q0zh08yt_20.jpg",
    title: "Wreath Ceremony — Sri. K. Sukumaran",
    caption: "Floral tribute at the Kerala Kaumudi editor's death anniversary observance",
    year: "Tribute",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/nkcj0abk_21.jpg",
    title: "State Kalaripayattu Festival",
    caption: "Chairing the State Kalaripayattu Festival at Jimmy George Indoor Stadium",
    year: "30 March 2002",
    category: "Sports"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/ntt1e3rh_22.jpg",
    title: "ANACI Chairman — Taking Over",
    caption: "Taking-over function as Chairman of the Anti-Narcotic Action Centre of India, New Delhi",
    year: "New Delhi",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/0f0hz0rc_23.jpg",
    title: "Solidarity with C. K. Janu",
    caption: "Standing with tribal leader C. K. Janu during the Nilppu Sathyagraham",
    year: "Solidarity",
    category: "Service"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/9m803xy7_24.jpg",
    title: "K. Balakrishnan Samskarika Pathrapravarthaka Samithi",
    caption: "With the State Committee at the M. N. V. G. Adiyodi Memorial Hall",
    year: "State Committee",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/xg5o1dy2_25.jpg",
    title: "Audience with the Governor",
    caption: "Submitting a memorandum to His Excellency the Governor of Kerala, Justice Sri. P. Sadasivam",
    year: "Memorandum",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/rr3rapbv_26.jpg",
    title: "With My Guru & Mentor",
    caption: "A young Shaji with his grandmother Smt. I. Gourikutty, retired Headmistress — his lifelong guru and mentor",
    year: "Childhood",
    category: "Family"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/a1h13arb_27.jpg",
    title: "Kerala Leaders Meet",
    caption: "Inaugurating the All-India Confederation of SC/ST Organisations — Kerala Leaders Meet",
    year: "Inauguration",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/j8pp42dh_28.jpg",
    title: "Ponnada from the Speaker",
    caption: "Receiving the Ponnada from Kerala Legislative Assembly Speaker Sri. Therambil Ramakrishnan",
    year: "2005",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/uhwrz9u2_29.jpg",
    title: "On the Felicitation Stage",
    caption: "On stage with dignitaries during a state-level recognition function",
    year: "Public Event",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/xwfpnztj_30.jpg",
    title: "Drug Abuse Observance — Kanakakunnu Palace",
    caption: "Presiding over the International Day Against Drug Abuse function at Kanakakunnu Palace, Trivandrum",
    year: "2007",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/llyf5v3b_31.jpg",
    title: "Nutritional Week — 2007",
    caption: "At the inaugural function of \"Nutritional Week 2007\" — lighting the ceremonial lamp",
    year: "2007",
    category: "Service"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/pcvti7w3_32.jpg",
    title: "Medical Mission Hospital — Inauguration",
    caption: "Hon. Minister Sri. Kodiyeri Balakrishnan felicitating Dr. Shaji Prabhakaran",
    year: "Inauguration",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/xxa8672b_33.jpg",
    title: "A Motorcycle for the Differently-Abled",
    caption: "Distributing a free motorcycle to a physically-challenged person — DDRC initiative",
    year: "Charity",
    category: "Service"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/oivh0mgy_35.jpg",
    title: "71st Sivagiri Theerthadana Mahamaham",
    caption: "Speaking at the 71st Sivagiri Theerthadana Mahamaham — Sree Narayana Guru's annual pilgrimage assembly",
    year: "Dec 30 – Jan 1, 2004",
    category: "Public Life"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/s7ka9j13_36.jpg",
    title: "Mangalam — \"Charithramezhuthi Dr. Shaji Prabhakaran Viramikkunnu\"",
    caption: "Mangalam newspaper feature on Dr. Shaji's retirement after 28 years of distinguished medical service",
    year: "29 June 2006",
    category: "Press"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/tf7cfya3_aa.jpeg",
    title: "My First Consultation Fee — Rs. 10",
    caption: "Achach's sister and her husband Adv. C. Narayanan — she handed me my very first consulting fee of Rs. 10 in 1975",
    year: "1975",
    category: "Family"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/gt25lis7_aaa.jpeg",
    title: "Kunju Pillai Sir",
    caption: "A portrait of Kunju Pillai Sir — a guiding figure of unwavering principle",
    year: "Portrait",
    category: "Family"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/ix42wtf9_aad.jpeg",
    title: "Family & Colleagues Gathering",
    caption: "A family and close-circle gathering — a quiet record of the people who walked alongside through the years",
    year: "Memory",
    category: "Family"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/eks66fii_aav.jpeg",
    title: "Sukumar Azhikode Memorial Award",
    caption: "Receiving the Sukumar Azhikode Memorial Award at the Trust's annual ceremony — the inscribed plaque carries the Doctor's own portrait",
    year: "Award",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/7h294rin_aagf.jpeg",
    title: "With Rhea Nakul",
    caption: "A Christmas moment with granddaughter Rhea Nakul — three generations carrying forward the same quiet joy",
    year: "Christmas",
    category: "Family"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/k2if0hq4_d.jpeg",
    title: "16·06·74 — The First Day",
    caption: "\"The day I started my journey with my patients\" — a framed memento marking 16 June 1974, the very first day of a lifelong vocation",
    year: "16 June 1974",
    category: "Service"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/8t4354sv_WhatsApp%20Image%202026-05-15%20at%2008.26.33.jpeg",
    title: "Ancestral Portrait",
    caption: "A treasured framed portrait of the elder generation — the quiet foundation from which a long life of service was built",
    year: "Family",
    category: "Family"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/iy8flhom_WhatsApp%20Image%202026-05-15%20at%2008.26.44.jpeg",
    title: "Kerala Kaumudi \"Legacy Makers\" Award",
    caption: "Receiving the Kerala Kaumudi Legacy Makers Award from His Excellency the Governor of Kerala, Sri. Arif Mohammed Khan — at the 113th Anniversary celebrations, Hotel Apollo Dimora, Trivandrum",
    year: "Kerala Kaumudi 113th Anniversary",
    category: "Press"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/mlxi8jxs_WhatsApp%20Image%202026-05-15%20at%2008.26.44x.jpeg",
    title: "Dr. Sukumar Azhikode Memorial National Award",
    caption: "Conferred by the Dr. Sukumar Azhikode Smaraka Desheeya Trust — President: Sasthamthala Sahadevan · General Secretary: Panavila Rajasekharan",
    year: "2025",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/6oo9sauk_WhatsApp%20Image%202026-05-15%20at%20x.jpeg",
    title: "Sree Narayana Samskarika Samithi — Send-off",
    caption: "Felicitation plaque from the Sree Narayana Samskarika Samithi on the occasion of his journey to America, in service of the Samithi's international outreach",
    year: "American Journey",
    category: "Honors"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/99vr7lp8_WhatsApp%20Image%202026-05-12%20at%2014.31.24.jpeg",
    title: "Family Portrait",
    caption: "A treasured family portrait — the three at the heart of everything",
    year: "Family",
    category: "Family"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/3mr7xaw6_WhatsApp%20Image%202026-05-12%20at%2013.41.00.jpeg",
    title: "Sree Narayana College, Quilon — B.Sc. Botany, 1969-70",
    caption: "The outgoing B.Sc. (Botany Main) class of 1969-70 at Sree Narayana College, Quilon. The young P. Shaji stands among classmates whose names live on in the inscription below — the season just before medicine called him onward.",
    year: "1969-70",
    category: "Education",
    photoKey: "college-bsc-1970"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_prabhakaran-md/artifacts/e1g7790l_WhatsApp%20Image%202026-05-06%20at%2007.44.59.jpeg",
    title: "10th Standard — English Medium High School, Mayyanad",
    caption: "Class photograph from his 10th standard year at English Medium High School, Mayyanad — the very first chapter of a long life in learning",
    year: "c. 1966",
    category: "Education",
    photoKey: "school-1966"
  }
];

export const BLOGS = [
  {
    id: "b1",
    title: "The Quiet Revolution in Stroke Care — Kerala 2025",
    excerpt: "Two decades ago, stroke meant disability. Today, with thrombolysis and 24×7 stroke units, Kerala leads India in time-to-needle outcomes.",
    body: "Stroke care has transformed from a fatalistic diagnosis into a time-bound emergency. In Kerala, the establishment of dedicated stroke units, public ambulance networks, and 24×7 thrombolysis services across district hospitals has dramatically reduced disability rates. This piece reflects on three decades of bedside neurology and the systemic shifts that made it possible.",
    date: "2025-06-12",
    category: "Neurology",
    cover: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=900&q=80"
  },
  {
    id: "b2",
    title: "Sree Narayana Guru and the Modern Physician",
    excerpt: "\"One Caste, One Religion, One God for Man.\" How the Guru's universalism still shapes the ethics of medical practice in Kerala.",
    body: "The teachings of Sree Narayana Guru — equality, compassion, education for all — formed the moral spine of Kerala's social renaissance. For a doctor practicing in this land, they remain not historical artefacts but daily practical guides on how to treat the poorest patient with the same dignity as the wealthiest.",
    date: "2025-04-04",
    category: "Philosophy",
    cover: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=900&q=80"
  },
  {
    id: "b3",
    title: "Why I Still Run Free Camps After Retirement",
    excerpt: "Retirement from the medical college never meant retirement from medicine. A reflection on monthly community treatment camps.",
    body: "After leaving the principal's chair at Alappuzha Medical College, the question I was most often asked was — what next? My answer has been the same every month for years: a folding table, a stethoscope, and whoever walks through the door.",
    date: "2025-02-21",
    category: "Community",
    cover: "https://images.unsplash.com/photo-1631815587646-b85a1bb027e1?w=900&q=80"
  }
];

export const EVENTS = [
  {
    id: "e1",
    title: "Free Community Health Camp",
    date: "2025-08-10",
    location: "Mayyanad, Kollam",
    type: "upcoming",
    description: "Monthly free consultation camp — neurology screening, BP & diabetes check-up, free medicines for the elderly."
  },
  {
    id: "e2",
    title: "Neuro Samvadham — Public Lecture",
    date: "2025-09-02",
    location: "Thiruvananthapuram",
    type: "upcoming",
    description: "Public lecture series on stroke prevention and brain health — open to all."
  },
  {
    id: "e3",
    title: "Book Release — Hindu Budhamatham",
    date: "2025-05-20",
    location: "Kerala Press Club, Trivandrum",
    type: "past",
    description: "Released Dr. Shaji's 15th book on the philosophical interplay between Hinduism and Buddhism."
  },
  {
    id: "e4",
    title: "Sree Narayana Trust Medical Outreach",
    date: "2025-03-15",
    location: "Kollam",
    type: "past",
    description: "Multi-specialty camp serving 600+ patients from coastal villages."
  }
];

export const RELATIVES = [
  "Sri. A. Sekharan, B.A.",
  "Sri. A. Ramachandran, B.A.",
  "Major General S.N. Rajan",
  "Dr. S. Balaji, IPS (M.A. Eng, Ph.D., LL.M)",
  "Sri. Madhu, IAS",
  "Er. K. Suresh Raj, B.Tech, M.A. (Eng), M.I.E (India)",
  "Justice S. Sirijagan, LL.M",
  "Fr. Dr. Ferdinant Kayavil, Ph.D. (Theology)",
  "Prof. P.K.G. Purushothaman",
  "Prof. Dr. N. Manilal Kothari (M.Sc., Ph.D.)",
  "Sri. M. Prabhakaran Thampi",
  "Dr. R. Gopimani — M.Sc. (Agri), Ph.D. (Agri)"
];
